import React from 'react'
import { Typography } from 'antd';
const { Title, Paragraph } = Typography;

export default function Roadtex() {
    return (
    <Typography>
      <Title level={2}>介绍</Title>
      <Paragraph>
        道路材质功能用于修改道路各个部位的贴图以及贴图的缩放、旋转、亮度、对比度、色相和饱和度等参数。可修改的部位包括路面、人行道、自行车道、绿化带、
        路缘石、路肩和边坡。可通过主界面左侧区域的材质菜单按钮打开道路材质操作界面。
      </Paragraph>
    </Typography>
  )
}
